var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcDiamond12 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.187 9.83 1.219 5.099a1 1 0 0 1-.128-.198h9.818a1 1 0 0 1-.128.198L6.813 9.831c-.095.115-.219.208-.36.272a1.1 1.1 0 0 1-.906 0 1 1 0 0 1-.36-.272m5.716-5.73a1 1 0 0 0-.202-.27L9.24 2.484a1.1 1.1 0 0 0-.734-.283H3.493a1.1 1.1 0 0 0-.733.283L1.3 3.831a1 1 0 0 0-.203.269z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDiamond12);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };